import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const authToken = authService.getAuthToken();
  const assetsI18nReq = request.url.indexOf('assets/i18n') >= 0;

  const authReq =
    !assetsI18nReq && authToken
      ? request.clone({ setHeaders: { Authorization: `Bearer ${authToken}` } })
      : request;

  return next(authReq);
};
